import React, { useEffect, useState } from "react";
import { Modal, Button, IconButton } from "@mui/material";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CloseIcon from "@mui/icons-material/Close";

// Register Chart.js components + datalabels
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const GraphDetailsModal = ({ open, onClose, data, patientName ,handleViewPdf}) => {
  const [chartData, setChartData] = useState(null);
  const [meanValue, setMeanValue] = useState(null);

  useEffect(() => {
    if (data && Array.isArray(data) && data.length > 0) {
      const labels = data.map((item) =>
        new Date(item.TDate).toLocaleDateString()
      );
      const values = data.map((item) => item.Quantitative);

      const mean = values.reduce((sum, v) => sum + v, 0) / values.length;
      setMeanValue(mean.toFixed(2));

      setChartData({
        labels,
        datasets: [
          {
            label: data[0].TestName,
            data: values,
            borderColor: "#0FB7A4", // mild teal
            backgroundColor: "rgba(15, 183, 164, 0.2)", // light teal shade
            tension: 0.3,
            pointBackgroundColor: "#0FB7A4",
          },
          {
            label: `Mean Value ${mean.toFixed(2)}`,
            data: Array(values.length).fill(mean),
            borderColor: "orange",
            borderDash: [6, 6],
            pointRadius: 0,
            fill: false,
          },
        ],
      });
    }
  }, [data]);

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      datalabels: {
        color: "black",
        align: "top",
        font: { weight: "bold" },
        formatter: (value, context) => {
          if (context.datasetIndex === 0) {
            return value;
          }
          return "";
        },
      },
    },
    scales: {
      y: {
        beginAtZero: false,
      },
    },
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          padding: 20,
          background: "white",
          maxWidth: 650,
          margin: "50px auto",
          borderRadius: 8,
          display: "flex",
          flexDirection: "column",
          minHeight: "80vh",
        }}
      >
        {!data || data.length === 0 ? (
          <p>No Data Available</p>
        ) : !chartData ? (
          <p>Loading...</p>
        ) : (
          <>
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: "8px",
                borderBottom: "2px solid #eee", // underline below header
              }}
            >
              <h3 style={{ color: "#0FB7A4", margin: 0 }}>{patientName}</h3>
              <IconButton onClick={onClose} sx={{ color: "grey.800" }}>
                <CloseIcon />
              </IconButton>
            </div>

            {/* Test Name + latest value */}
            <h2
              style={{
                color: "red",
                textAlign: "center",
                margin: "15px 0",
                
                paddingBottom: "6px",
              }}
            >
              {data[0].TestName} 
            </h2>

            {/* Graph */}
            <Line data={chartData} options={chartOptions} redraw />

            {/* Details */}
            <div style={{ marginTop: 10 }}>
              <span style={{ color: "GrayText" }}>
                Reference Range: {data[0].CompoRefRange}
              </span>
              <br />
              <span style={{ color: "GrayText" }}>
                Unit: {data[0].CompoUnit} | Mean Value: {meanValue}
              </span>
            </div>

            {/* Footer with centered button */}
            <div
              style={{
                marginTop: "auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
  variant="contained"
  sx={{
    mt: 2,
    borderRadius: 20,
    backgroundColor: "#0FB7A4",
  }}
//   onClick={() => {
//     const patientId = data[0].; 
//     const testName = data[0].TestName;
//     const url = `https://rb-api.in:4436/RBReports/RB_Patient_Data/GRAPH/${patientId}/${testName}.pdf`;
//     window.open(url, "_blank"); 
//   }}
onClick={handleViewPdf}
>
  Download Graph Report
</Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default GraphDetailsModal;
